"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwapRecipe = void 0;
const shared_models_1 = require("@railgun-community/shared-models");
const utils_1 = require("../../utils");
const recipe_1 = require("../recipe");
const cookbook_debug_1 = require("../../utils/cookbook-debug");
class SwapRecipe extends recipe_1.Recipe {
    constructor() {
        super();
    }
    getLatestQuote() {
        return this.quote;
    }
    getBuySellAmountsFromRecipeOutput(recipeOutput) {
        try {
            if (!recipeOutput) {
                return undefined;
            }
            const firstOutputIndex = 0;
            const unshieldStepOutput = recipeOutput.stepOutputs[firstOutputIndex];
            const unshieldFee = unshieldStepOutput.feeERC20AmountRecipients?.find(fee => {
                return (0, utils_1.compareERC20Info)(fee, this.sellERC20Info);
            });
            if (!unshieldFee) {
                throw new Error('Expected unshield fee to match sell token.');
            }
            const swapStepOutput = recipeOutput.stepOutputs[2];
            if (swapStepOutput.name !== '0x Exchange Swap') {
                throw new Error('Expected step output 3 to be 0x Exchange Swap.');
            }
            let buyOutput;
            let buyShieldFee;
            if ((0, shared_models_1.isDefined)(this.destinationAddress) &&
                !(0, utils_1.getIsUnvalidatedRailgunAddress)(this.destinationAddress)) {
                buyOutput = swapStepOutput.outputERC20Amounts.find(outputAmount => {
                    return (0, utils_1.compareERC20Info)(outputAmount, this.buyERC20Info);
                });
                if (!buyOutput) {
                    throw new Error('Expected swap output to match buy token.');
                }
            }
            else {
                const lastOutputIndex = recipeOutput.stepOutputs.length - 1;
                const shieldStepOutput = recipeOutput.stepOutputs[lastOutputIndex];
                buyOutput = shieldStepOutput.outputERC20Amounts.find(outputAmount => {
                    return (0, utils_1.compareERC20Info)(outputAmount, this.buyERC20Info);
                });
                if (!buyOutput) {
                    throw new Error('Expected swap output to match buy token.');
                }
                buyShieldFee = shieldStepOutput.feeERC20AmountRecipients?.find(fee => {
                    return (0, utils_1.compareERC20Info)(fee, this.buyERC20Info);
                });
                if (!buyShieldFee) {
                    throw new Error('Expected shield fee to match buy token.');
                }
            }
            return {
                sellUnshieldFee: unshieldFee.amount,
                buyAmount: buyOutput.expectedBalance,
                buyMinimum: buyOutput.minBalance,
                buyShieldFee: buyShieldFee?.amount ?? 0n,
            };
        }
        catch (err) {
            if (!(err instanceof Error)) {
                throw err;
            }
            cookbook_debug_1.CookbookDebug.error(err);
            return undefined;
        }
    }
}
exports.SwapRecipe = SwapRecipe;
